import { render, staticRenderFns } from "./Mensaje.vue?vue&type=template&id=53a05e6a"
import script from "./Mensaje.vue?vue&type=script&lang=js"
export * from "./Mensaje.vue?vue&type=script&lang=js"
import style0 from "./Mensaje.vue?vue&type=style&index=0&id=53a05e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports